const messages = {
  'en' : {
      Biography: 'Biography',
      Landscape : 'Landscape',
      Watercolor: 'Watercolor',
      Interiors: 'Interiors',
      Events: 'Events',
      Contact: 'Contact',
      Language: 'Language',
      Spanish: 'Spanish',
      English: 'English',
      French: 'French',
  },
  'es' : {
      Biography: 'Biografía',
      Landscape: 'Paisaje',
      Watercolor: 'Acuarela',
      Interiors: 'Interiores',
      Events: 'Eventos',
      Contact: 'Contacto',
      Language: 'Idioma',
      Spanish: 'Español',
      English: 'Inglés',
      French: 'Francés'
  },
  'fr' : {
      Biography: 'Biographie',
      Landscape: 'Paysage',
      Interiors: 'Intérieurs',
      Watercolor: 'Aquarelle',
      Events: 'Événements',
      Contact: 'Contact',
      Language: 'Langue',
      Spanish: 'Espagnol',
      English: 'Anglaise',
      French: 'Française'
  }
}
export default messages
